import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ContentWithSamePageLinks} from 'app-ui-componentlibrary/dist/componentLibrary/form/ContentWithSamePageLinks';

export {ContentWithSamePageLinks};
export default connectWithCore(ContentWithSamePageLinks);
